export enum INTERNAL_ANNOUNCEMENT_STATUS {
  /** Chờ duyệt */
  WAITING_APPROVE = 13,
  /** Đang hoạt động */
  ACTIVE = 14,
  /** Đã đóng */
  INACTIVE = 15
}
